import React from 'react';
import { DetailedInfoTile, InfoItem } from '../shared/DetailedInfoTile';
import { Loader } from '../../../components/Loader';
import { userStatsSelector } from './userStatsSelector';
import { useGetUserStatsQuery } from '../../../graphql/api';
import { withErrorBoundary } from '../../../components/withErrorBoundary';
import { Props } from '../types';

const UserStatsContainer: React.FC<Props> = ({ userId }) => {
  const { data } = useGetUserStatsQuery<InfoItem[], Error>(
    { userId },
    {
      select: userStatsSelector,
      queryKey: ['userStats', userId],
    },
  );

  if (data) {
    return <DetailedInfoTile infoItems={data} />;
  }

  return <Loader />;
};

export default withErrorBoundary(UserStatsContainer);
